import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  ActionType,
  IDeletePatientResponse,
  IDeletePatientPayload,
} from "models/patients/deletePatient";
import { httpStatus } from "configs/httpStatus";
import { deletePatient } from "services/patients";
import { handleSuccessAction, handleErrorAction } from "./deletePatientActions";

function* deletePatientSaga({ payload }: { payload: IDeletePatientPayload }) {
  try {
    const response: IDeletePatientResponse = yield call(deletePatient, payload);
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccessAction(response));
    } else if (
      response.status === httpStatus.StatusUnauthorized ||
      response.status === httpStatus.StatusForbidden
    ) {
      yield put(handleErrorAction(response.message || ""));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onDeletePatientWatcher() {
  yield takeLatest(ActionType.DELETE_PATIENT as any, deletePatientSaga);
}

export default [fork(onDeletePatientWatcher)];
